import ShipTypeList from '../components/lists/ShipTypeList';
import { useShipTypes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminShipTypesPage = ({ routes }) => {
  const { allShipTypes } = useShipTypes();

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <ShipTypeList id="shipTypes" shipTypes={allShipTypes} />
    </Layout>
  );
};

export default AdminShipTypesPage;
